'use strict';
(function($){

	var exportToExcel = function(){
		var uri = 'data:application/vnd.ms-excel;base64,';
		var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
		var base64 = function(s) {
			return window.btoa(unescape(encodeURIComponent(s)))
		};

		var format = function(s, c) {
			return s.replace(/{(\w+)}/g, function(m, p) {
				return c[p];
			})
		};

		var $table = $('table');
		var $labels = $table.find('thead').find('th');
		var $rows = $table.find('tbody').find('tr');

		var html = '';
		html += '<thead>';
		for(var i in Object.values($labels) ){
			html += '<th>' + $($labels[i]).text() + '</th>';
		}
		html += '</thead>';
		html += '<tbody>';
		for(var i in Object.values($rows)){
			if($($rows[i]).is(':visible')){
				html += '<tr>';
				var $td = $($rows[i]).find('td');
				for(var iv in Object.values($td)){
					if($($td[iv]).find('.inline-editable').length > 0){
						if($($td[iv]).find('.inline-editable').find('span').length > 0){
							html += '<td>' + $($td[iv]).find('.inline-editable').find('span').text() + ' ' + $($td[iv]).find('.inline-editable').text() + '</td>';
						}else{
							html += '<td>' + $($td[iv]).find('.inline-editable').text() + '</td>';
						}
					}else{
						if($($td[iv]).find('span').length > 0){
							html += '<td>' + $($td[iv]).find('span').text() + '</td>';
						}else{
							html += '<td>' + $($td[iv]).text() + '</td>';
						}
					}
				}
				html += '</tr>';
			}
		}
		html += '</tbody>';

		var ctx = {
			worksheet : 'Worksheet',
			table : html
		}

		if (isIE){
			var IEwindow = window.open();
			IEwindow.document.write('sep=,\r\n' + format(template, ctx));
			IEwindow.document.close();
			IEwindow.document.execCommand('SaveAs', true, "export.xls");
			IEwindow.close();
		}else{
			var link = document.createElement("a");
			link.download = "export.xls";
			link.href = uri + base64(format(template, ctx));
			link.click();
		}

	}

	var exportToCsv = function(){
		var $table = $('table');
		var $labels = $table.find('thead').find('th');
		var $rows = $table.find('tbody').find('tr');
		var csv = '';
		var mime = 'data:text/csv;charset=utf-8,\uFEFF';
		var columns = [];
		var separator = ';';

		$labels.each(function(i){
			if($(this).text() == ''){
				columns.push(false);
			}else{
				columns.push(true);
				csv += $(this).text().trim() + separator;
			}
		});
		csv = csv.substring(0,csv.length - 1);
		csv += "\n";

		$rows.each(function(){
			if($(this).is(':visible')){
				var $tds = $(this).find('td');
				$tds.each(function(i){
					if(columns[i]){
						if($(this).find('.inline-editable').length > 0){
							if($(this).find('.inline-editable').find('span').length > 0){
								csv += $(this).find('.inline-editable').find('span').text().trim() + ' ' + $(this).find('.inline-editable').text().trim() + separator;
							}else{
								csv += $(this).find('.inline-editable').text().trim() + separator;
							}
						}else{
							if($(this).find('span').length > 0){
								csv += $(this).find('span').text().trim() + separator;
							}else{
								csv += $(this).text().trim() + separator;
							}
						}
					}
				});
				csv = csv.substring(0,csv.length - 1);
				csv += "\n";
			}
		});

		var isIE = /*@cc_on!@*/false || !!document.documentMode;
		if (isIE){
			var blob = new Blob([csv], {
				type: "text/plain;charset=utf-8"
			});
			saveAs(blob, "export.csv");

		}else{
			var data = encodeURI(mime + csv);
			var link = document.createElement("a");
			link.setAttribute("href", data);
			link.setAttribute("download", "export.csv");
			link.click();
		}
	}

	var $exportButton = $('#export');
	$exportButton.click(function(ev){
		exportToCsv();
	});



}(jQuery));
